import * as API from 'aws-amplify/api';
import { fetchAuthSession } from 'aws-amplify/auth';
import { Apis } from '../constants';

interface FetchOptions {
  method: string;
  headers: object;
  body?: any;
  response?: boolean;
}

export const testUrlPrefix = 'https://devapi.gigg.com';

async function localFetch(path: string, options: FetchOptions, api: string) {
  const authToken = (await fetchAuthSession()).tokens?.idToken?.toString() || '';

  const headers = {
    ...(options.headers || {}),
    Authorization: authToken,
  };

  const localPathPrefix = process.env.NODE_ENV === 'test' ? testUrlPrefix : process.env.REACT_APP_LOCAL_API_URL;

  const fetchPath = `${localPathPrefix}/${api}${path}`;
  const opt = {
    ...options,
    headers,
  };

  const res = await fetch(fetchPath, opt);

  if (res.status === 204) {
    return res;
  }

  const data = await res.text();

  if (!res.ok) {
    return Promise.reject(new Error(data));
  }

  return {
    ...res,
    data: data ? JSON.parse(data) : {},
  };
}

export default class APIService {
  static isLocalEnvironment = process.env.REACT_APP_LOCAL_API_URL || process.env.NODE_ENV === 'test';

  static async GET(path: string, api = Apis.CORE, settings = {}): Promise<any> {
    const options = {
      headers: {},
      response: true,
      ...settings,
    };

    if (this.isLocalEnvironment) {
      return await localFetch(
        path,
        {
          ...options,
          method: 'GET',
        },
        api,
      );
    }

    const res = await API.get({ apiName: api, path, options }).response;
    const data = await res.body.json();
    return { data };
  }

  static async POST(path: string, api = Apis.CORE, body = {}, headers = {}, settings = {}): Promise<any> {
    const options = {
      body,
      headers,
    };

    if (this.isLocalEnvironment) {
      const localOptions = {
        body: body instanceof FormData ? body : JSON.stringify(body),
        headers: {
          ...headers,
          ...(body instanceof FormData ? {} : { 'Content-Type': 'application/json' }),
        },
        method: 'POST',
      };
      return localFetch(path, localOptions, api);
    }

    const res = await API.post({ apiName: api, path, options }).response;
    const data = await res.body.json();

    return { data };
  }

  static async DELETE(path: string, api = Apis.CORE, headers = {}): Promise<any> {
    const options = {
      headers,
    };

    if (this.isLocalEnvironment) {
      return await localFetch(
        path,
        {
          ...options,
          method: 'DELETE',
        },
        api,
      );
    }

    return API.del({ apiName: api, path, options }).response;
  }

  static async PUT(path: string, api = Apis.CORE, body = {}, headers = {}): Promise<any> {
    const options = {
      body,
      headers,
    };

    if (this.isLocalEnvironment) {
      const localOptions = {
        body: body instanceof FormData ? body : JSON.stringify(body),
        headers: {
          ...headers,
          ...(body instanceof FormData ? {} : { 'Content-Type': 'application/json' }),
        },
        method: 'PUT',
      };

      return localFetch(path, localOptions, api);
    }

    const res = await API.put({ apiName: api, path, options }).response;
    const data = await res.body.json();
    return { data };
  }
}
